import modelService from '@/services/model'
import axios from '@/axios'
import authService from '@/services/authentication'

export default {
  // NOTE: some times we want to pull only tickets for a specific project or board, then we can use these contextualised methods.
  // We should not need these for anythingbut index, since we have direct access to tickets on the API

  projectIndex: (cbOk, cbErr, projectId) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/keys.json`)
  },

  projectCreate: (cbOk, cbErr, projectId, instance) => {
    return modelService.create(cbOk, cbErr, instance, `/projects/${projectId}/keys.json`)
  },

  projectShow: (cbOk, cbErr, projectId, id) => {
    return modelService.show(cbOk, cbErr, `/projects/${projectId}/keys/${id}.json`)
  },

  projectUpdate: (cbOk, cbErr, projectId, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/projects/${projectId}/keys/${instance.id}.json`)
  },

  projectDelete: (cbOk, cbErr, projectId, id) => {
    return modelService.delete(cbOk, cbErr, `/projects/${projectId}/keys/${id}.json`)
  },

  projectGenerate: (cbOk, cbErr, projectId) => {
    let url = `/projects/${projectId}/keys/generate.json`
    return axios.get(url)
    .then(response => {
      if (response.data) {
        if (cbOk) cbOk(response.data)
      }
    })
    .catch(err => {
      if (err && err.response && err.response.status === 401) {
        authService.logout()
      }
      if (cbErr) cbErr(err)
    })
  }

}



// WEBPACK FOOTER //
// ./src/services/key.js